import React from "react";
import { useState } from "react";
import { Button } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import AddIcon from '@mui/icons-material/Add';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { useNavigate } from "react-router-dom";

const UserTopbar = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <SearchBar
            searchTerm={searchTerm}
            setDebouncedSearchTerm={setSearchTerm}
            placeholder="Search..."
          />

        </div>
        <div className="right_s">
          <Button className="btn btn_primary"><FileDownloadOutlinedIcon /> Export CSV</Button>
          <Button className="btn btn_primary" onClick={() => navigate('/manage-users/add')}><AddIcon /> Add Customer</Button>
        </div>
      </div>
    </>
  );
};

export default UserTopbar;
